export default "__VITE_ASSET__BBpGsr2F__"